import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vue-toastification/dist/index.css";
import "./assets/css/index.css";
import "./assets/css/app.css"; // Here
import VueGtag from "vue-gtag";

const app = createApp(App);
app.use(store);
app.use(router);
app.use(
  VueGtag,
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pageTrackerTemplate(to: any) {
      return {
        page_title: "louisBlog",
        page_path: to.path,
      };
    },
    config: {
      id: process.env.VUE_APP_GTAG,
    },
  },
  router
);

app.mount("#app");
